import { CustomMarker } from "@/components/map/utils/customs";
import * as L from "leaflet";

export const getMyLocation = (map) => {
    const successCallback = (position) => {
        var coordinates = new L.LatLng(position?.coords?.latitude, position?.coords?.longitude) 
        map.flyTo(coordinates, 18);
        L.marker(coordinates, {icon: CustomMarker}).addTo(map);
      };
      
      const errorCallback = (error) => {
        alert(error)
      };

      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
      };

    navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options);
}